import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  backdrop: {
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 2500,
    background: 'rgba(0,0,0,.54)',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    minWidth: 380,
    minHeight: 80,
    maxWidth: '80%',
    maxHeight: '80%',
    display: 'flex',
    flexFlow: 'column',
    overflow: 'hidden',
    position: 'relative',
    zIndex: '1500',
    outline: 'none',
    borderRadius: '2px',
    boxShadow:
      '0 7px 9px -4px rgba(0, 0, 0, .2), 0 14px 21px 2px rgba(0, 0, 0, .14), 0 5px 26px 4px rgba(0, 0, 0, .12)',
    background: '#fff'
  },
  title: {
    marginBottom: '20px',
    padding: '24px 24px 0',
    fontSize: '20px',
    fontWeight: 500,
    letterSpacing: '.005em',
    lineHeight: '26px'
  },
  content: {
    padding: '0 24px 24px',
    flex: 1,
    flexBasis: 'auto',
    overflow: 'auto',
    position: 'relative'
  },
  actions: {
    minHeight: '52px',
    padding: '8px 8px 8px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'relative'
  },
  button: {
    minWidth: '88px',
    minHeight: '36px',
    margin: '6px 8px',
    padding: '0 16px',
    display: 'inline-block',
    position: 'relative',
    overflow: 'hidden',
    userSelect: 'none',
    cursor: 'pointer',
    background: 'none',
    border: 0,
    borderRadius: 2,
    transition: 'all .4s cubic-bezier(.25, .8, .25, 1)',
    color: 'currentColor',
    fontSize: '14px',
    fontStyle: 'inherit',
    fontVariant: 'inherit',
    fontWeight: 500,
    lineHeight: '36px',
    textAlign: 'center',
    textTransform: 'uppercase',
    textDecoration: 'none',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    outline: 'none',
    ':hover': {
      background: 'rgb(226, 226, 226)'
    }
  },
  visible: {
    visibility: 'visible',
    display: 'flex',
    opacity: 1,
    transform: 'translate3d(0px, 0px, 0px)'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Common/Dialog/styles.js